module.exports = __webpack_public_path__ + "static/media/SN15110048_060222.d41d8cd9.csv";